module.exports = __webpack_public_path__ + "img/bg_huzhao@2x.41419b61.png";